import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { debounce } from 'lodash';
// import axios from 'axios';
import isIEbrowser from '../helpers/is-IE';
import domReady from '../helpers/dom-ready';

// export default
class Menu {
  static init(...parameters) {
    return new Menu(...parameters);
  }

  constructor() {
    this.container = document.querySelector('.brix-multi-menu');
    this.solidHeader = document.querySelector('header.-solid');
    this.menuBar = this.container.querySelector('.menu-bar');
    this.menusContainer = this.container.querySelector('.menu-container');
    this.subMenusContainer = this.container.querySelector('.sub-menus');
    this.toggleMenuButton = this.container.querySelector('.hamburger-button');
    this.menuItemsWithChildren = document.querySelectorAll('.primary-menu li.-has-children.-level-1');
    this.mobileMenuItemsWithChildren = document.querySelectorAll('.-primary-menu-mobile li.-has-children.-level-1');

    const isHiddenMenu = document.body.classList.contains('-hidden-menu');
    //  Retailer login
    this.overlay = document.querySelector('.login-overlay');
    this.loginButton = document.querySelector('.upper-menu-dealer-login');
    // this.logOffButton = document.querySelector('.upper-menu-dealer-logoff');
    if (this.loginButton) {
      this.loginButton.addEventListener('click', (event) => {
        this.upperMenuOpenCloseLogInWindow(event);
      });
    }
    // if (this.logOffButton) {
    //   this.logOffButton.addEventListener('click', () => {
    //     this.upperMenuLogOff();
    //   });
    // }

    this.IE = isIEbrowser();

    if (this.IE && this.menuBar) {
      this.menuBar.classList.add('-IE');
    }

    // this.mobileSearchOpen = false;
    // this.clickOnSearchElement = false;
    this.showDropdownSearch = false;
    this.showMobileSearch = false;
    this.fullScreenMenu = false;
    this.menuWidth = document.body.offsetWidth;

    this.currentPageYOffset = null;

    let passiveSupported = false;
    try {
      const options = {
        // This function will be called when the browser attempts to access the passive property.
        get passive() {
          passiveSupported = true;
          return undefined;
        },
      };
      window.addEventListener('testPassive', null, options);
      window.removeEventListener('testPassive', null, options);
    } catch (ignored) {
      passiveSupported = false;
    }

    let disableNonActiveMenuDebouncing = false;
    const disableNonActiveMenuDebounce = () => {
      if (!disableNonActiveMenuDebouncing) {
        disableNonActiveMenuDebouncing = true;
        window.requestAnimationFrame(() => {
          this.disableNonActiveMenu();
          disableNonActiveMenuDebouncing = false;
        });
      }
    };
    window.addEventListener('resize', disableNonActiveMenuDebounce, passiveSupported ? { passive: true } : false);
    disableNonActiveMenuDebounce();

    let updatePageYOffsetDebouncing = false;
    const updatePageYOffsetDebounce = () => {
      if (!updatePageYOffsetDebouncing) {
        updatePageYOffsetDebouncing = true;
        window.requestAnimationFrame(() => {
          this.updatePageYOffset();
          updatePageYOffsetDebouncing = false;
        });
      }
    };
    window.addEventListener('resize', updatePageYOffsetDebounce, passiveSupported ? { passive: true } : false);
    window.addEventListener('orientationchange', updatePageYOffsetDebounce, passiveSupported ? { passive: true } : false);
    if (isHiddenMenu) {
      let lastScrollTop = window.pageYOffset || document.body.scrollTop;
      window.addEventListener('scroll', debounce(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop > lastScrollTop) {
          lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling

          this.container.classList.add('-collapsed');
          if (this.solidHeader) { this.solidHeader.classList.add('-collapsed'); }
        } else if (scrollTop + 200 < lastScrollTop) { // Scroll up 200px
          lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling

          this.container.classList.remove('-collapsed');
          if (this.solidHeader) { this.solidHeader.classList.remove('-collapsed'); }
        }
      }, 50));
    } else {
      window.addEventListener('scroll', updatePageYOffsetDebounce, passiveSupported ? { passive: true } : false);
    }
    updatePageYOffsetDebounce();

    /* Toggle menus */
    if (this.toggleMenuButton) {
      this.toggleMenuButton.addEventListener('click', () => {
        // this.showMobileSearch = false;
        // this.toggleFullscreenMenu();
        this.fromMainMenuButton();
      });
    }
    if (this.menuItemsWithChildren.length > 0) {
      [...this.menuItemsWithChildren].forEach((item) => this.addChildClickEventListener(item));
      document.body.addEventListener('click', (event) => {
        const openChildMenu = this.container.querySelector('.child-menu.-open');
        const menuBarWrapper = this.container.querySelector('.menu-bar-wrapper');
        if (
          openChildMenu
          && event.target !== openChildMenu
          && !openChildMenu.contains(event.target)
          && event.target !== menuBarWrapper
          && !menuBarWrapper.contains(event.target)
        ) {
          this.closeChildMenus();
        }
      });
    }

    if (this.mobileMenuItemsWithChildren.length > 0) {
      [...this.mobileMenuItemsWithChildren].forEach(
        (item) => this.addChildClickEventListener(item),
      );
    }

    /* Search */
    this.toggleSearchButton = this.container.querySelector('.toggle-search-button');
    this.searchForm = this.container.querySelector('.search-form');
    this.searchInput = this.searchForm.querySelector('input');
    this.searchButton = this.searchForm.querySelector('button');
    this.searchSuggestions = this.searchForm.querySelector('.search-suggestions');
    this.searchSuggestionsCancelButton = this.searchSuggestions.querySelector('button');
    this.dropdownSearchFormDesktop = document.querySelector('.dropdown-search-form-desktop');
    this.dropdownSearchFormDesktopButton = this.dropdownSearchFormDesktop.querySelector('button');
    this.dropDownSearchInput = this.dropdownSearchFormDesktop.querySelector('input');
    this.searchFormDesktop = document.querySelector('.search-form-desktop');

    this.setupSearchEventListeners();

    this.languageSelect = this.container.querySelector('.language-switcher');
    this.setupLanguageSelectEventListeners(this.languageSelect);

    this.languageSelectMobile = this.container.querySelector('.language-switcher-mobile');
    this.setupLanguageSelectEventListeners(this.languageSelectMobile);

    window.addEventListener('click', (e) => {
      this.checkClickInSearch(e);
    });
  }

  updateInput(value, element) {
    if (value === '') {
      element.classList.remove('-correct');
    } else {
      element.classList.add('-correct');
    }
  }

  clearErrorMessage() {
    const errorMessage = document.querySelector('.error-message');
    const errorPassword = document.querySelector('.user-password');
    const errorUsername = document.querySelector('.username');
    if (errorMessage && errorPassword) {
      errorMessage.innerHTML = '';
      errorPassword.classList.remove('-red');
      errorUsername.value = '';
      errorPassword.value = '';
      this.updateInput('', errorPassword);
      this.updateInput('', errorUsername);
    }
  }

  // upperMenuLogOff() {
  //   const login = document.querySelector('.log-in');
  //   const logout = document.querySelector('.log-out');
  //   const overlay = document.querySelector('.login-overlay');
  //   const endpointUrl = document.querySelector('input[name="logOff_endpoint"]').value;
  //   axios.get(endpointUrl)
  //     .then((response) => {
  //       if (response.status === 200) {
  //         if (login && logout) {
  //           login.classList.add('-hidden');
  //           logout.classList.remove('-hidden');
  //           overlay.classList.add('-visible');
  //           overlay.classList.remove('-hidden');
  //           setTimeout(() => {
  //             login.classList.remove('-hidden');
  //             logout.classList.add('-hidden');
  //             overlay.classList.remove('-visible');
  //             overlay.classList.add('-hidden');
  //             window.location.reload(true);
  //           }, 2000);
  //         }
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // }

  upperMenuOpenCloseLogInWindow(event) {
    if (this.overlay) {
      if (event.target.className === 'upper-menu-dealer-login' || event.target.parentNode.className === 'upper-menu-dealer-login' || event.target.parentNode.parentNode.className === 'upper-menu-dealer-login') {
        this.toggleFullscreenMenu();
        this.overlay.classList.remove('-hidden');
        this.overlay.classList.add('-visible');
        this.clearErrorMessage();
      }
    }
  }

  updatePageYOffset() {
    const pageYOffset = window.pageYOffset
      || document.documentElement.scrollTop
      || document.body.scrollTop
      || 0;
    if (this.currentPageYOffset === null || this.currentPageYOffset !== pageYOffset) {
      this.currentPageYOffset = pageYOffset;

      const { container } = this;
      if (container) {
        if (this.currentPageYOffset > 100) {
          container.classList.add('-collapsed');
          if (this.solidHeader) { this.solidHeader.classList.add('-collapsed'); }
        } else {
          container.classList.remove('-collapsed');
          if (this.solidHeader) { this.solidHeader.classList.remove('-collapsed'); }
        }
      }
    }
  }

  /* Disable duplicated menu for accesibility reasons */
  disableNonActiveMenu() {
    const desktopMenu = document.querySelector('.primary-menu');
    const mobileMenu = document.querySelector('.-primary-menu-mobile');
    if (desktopMenu && getComputedStyle(desktopMenu).display === 'none') {
      desktopMenu.setAttribute('aria-hidden', 'true');
      mobileMenu.removeAttribute('aria-hidden');
      this.desktopMenuActive = false;
      this.mobileMenuActive = true;
    }
    if (mobileMenu && getComputedStyle(mobileMenu).display === 'none') {
      mobileMenu.setAttribute('aria-hidden', 'true');
      desktopMenu.removeAttribute('aria-hidden');
      this.desktopMenuActive = true;
      this.mobileMenuActive = false;
      if (this.mobileSearchOpen) {
        this.closeMobileSearch();
      }
    }
  }

  /* Closes the main menu and opens the search menu after timer ends, if a menu is already open. */
  fromMainMenuButton() {
    if (this.fullScreenMenu && this.showMobileSearch) {
      setTimeout(() => {
        // this.showMobileSearch = false;
        this.toggleFullscreenMenu();
      }, 840);
    }
    this.showMobileSearch = false;
    this.toggleFullscreenMenu();
  }

  /* Closes the search menu and opens the main menu after timer ends, if a menu is already open. */
  fromSearchMenuButton() {
    if (this.fullScreenMenu && !this.showMobileSearch) {
      setTimeout(() => {
        this.toggleSearchSuggestions();
        // this.showMobileSearch = true;
        this.toggleFullscreenMenu();
      }, 840);
    }
    this.toggleSearchSuggestions();
    this.showMobileSearch = true;
    this.toggleFullscreenMenu();
  }

  toggleFullscreenMenu() {
    const { classList } = this.container;
    if (classList.contains('-active')) {
      this.fullScreenMenu = false;
      classList.remove('-active');
      enableBodyScroll(this.menusContainer);
      classList.add('-animate-out');
      setTimeout(() => {
        classList.remove('-animate-out');
        classList.remove('-show-search-suggestions');
        this.toggleMenuButton.classList.remove('-no-icon-animation');
        this.searchForm.classList.remove('-show');
        this.showSearchSuggestions = false;
        this.toggleSearchButton.classList.remove('-hide');
        this.menusContainer.scrollTop = 0;
      }, 800);
    } else {
      if (this.desktopMenuActive) this.closeChildMenus();
      this.fullScreenMenu = true;
      classList.add('-active');
      if (this.showMobileSearch) {
        this.toggleSearchButton.classList.add('-hide'); // hide search icon and show close icon.
        this.toggleMenuButton.classList.add('-no-icon-animation'); // Stops hamburger icon from animating.
        setTimeout(() => {
          this.searchForm.classList.add('-show');
        }, 400);
      } else {
        this.toggleSearchButton.classList.remove('-hide');
      }
      disableBodyScroll(this.menusContainer, {
        reserveScrollBarGap: true,
        paddingRightElement: this.menuBar,
      });
    }
  }

  toggleChildMenu(item, childmenu) {
    if (item.classList.contains('-open')) {
      // Close child menu
      item.classList.remove('-open');
      childmenu.classList.remove('-open');
      this.container.classList.remove('-open-child-menu');
      this.container.classList.add('-animate-out');
      setTimeout(() => this.container.classList.remove('-animate-out'), 800);
    } else {
      // Open child menu
      item.classList.add('-open');
      childmenu.classList.add('-open');
      this.container.classList.add('-open-child-menu');

      if (this.desktopMenuActive && this.container.classList.contains('-active')) {
        this.container.classList.remove('-active');
        enableBodyScroll(this.menusContainer);
      }
    }
  }

  addChildClickEventListener(item) {
    const link = item.querySelector('a');
    const childmenu = item.querySelector('.child-menu.-level-1');

    link.addEventListener('click', (event) => {
      event.preventDefault();
      this.toggleChildMenu(item, childmenu);
    });
  }

  closeChildMenus() {
    if (this.menuItemsWithChildren.length > 0) {
      [...this.menuItemsWithChildren].forEach((item) => {
        const childmenu = item.querySelector('.child-menu');

        if (childmenu) {
          childmenu.classList.add('-animate-out-fast');
          setTimeout(() => childmenu.classList.remove('-animate-out-fast'), 200);
          item.classList.remove('-open');
          childmenu.classList.remove('-open');
          this.container.classList.remove('-open-child-menu');
        }
      });
    }
  }

  setupLanguageSelectEventListeners(select) {
    if (select) {
      select.addEventListener('change', () => {
        const option = select.options[select.selectedIndex];
        if (option && option.value) {
          if (option.dataset.slug && window.pll_set_current_language) {
            window.pll_set_current_language(option.dataset.slug);
          }

          window.location.href = option.value;
        }
      });
    }
  }

  setupSearchEventListeners() {
    this.mobileMode = window.innerWidth < 1248;
    this.showSearchSuggestions = false;

    window.addEventListener('resize', debounce(() => {
      if (window.innerWidth < 1248) {
        if (!this.mobileMode) {
          this.mobileMode = true;
        }
      } else {
        this.mobileMode = false;
      }
    }, 50), false);

    this.toggleSearchButton.addEventListener('click', () => {
      this.fromSearchMenuButton();
    });

    this.searchForm.addEventListener('submit', (e) => {
      e.preventDefault(e);
      this.onSearch();
    }, false);

    this.searchSuggestionsCancelButton.addEventListener('click', (e) => {
      e.preventDefault();
      // this.toggleSearchSuggestions();
      this.fromSearchMenuButton();
    }, false);

    this.searchInput.addEventListener('focus', () => {
      if (this.mobileMode && !this.showSearchSuggestions) {
        this.toggleSearchSuggestions();
      }
    }, false);

    this.searchButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.onSearch();
    }, false);

    this.dropdownSearchFormDesktopButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.toggleDropdownSearch();
    }, false);

    this.searchFormDesktop.addEventListener('click', (e) => {
      e.preventDefault();
      this.toggleDropdownSearch();
    }, false);

    this.dropDownSearchInput.addEventListener('keyup', (e) => {
      e.preventDefault();
      if (e.key === 'Enter') {
        this.onDropdownSearch();
      }
    }, false);
  }

  toggleSearchSuggestions() {
    if (this.container.classList.contains('-show-search-suggestions')) {
      this.container.classList.remove('-show-search-suggestions');
      this.showSearchSuggestions = false;
    } else {
      this.container.classList.add('-show-search-suggestions');
      this.showSearchSuggestions = true;
    }
  }

  onSearch() {
    if (this.searchInput.value === '') {
      this.searchInput.focus();
      return;
    }

    const { searchUrl } = this.searchForm.dataset;
    const searchQuery = encodeURIComponent(this.searchInput.value).replace(/%20/g, '+');

    window.location.href = `${searchUrl}?search=${searchQuery}`;
  }

  toggleDropdownSearch() {
    if (this.dropdownSearchFormDesktop.classList.contains('-show-dropdown')) {
      this.dropdownSearchFormDesktop.classList.remove('-show-dropdown');
      this.showDropdownSearch = false;
    } else {
      this.dropdownSearchFormDesktop.classList.add('-show-dropdown');
      this.showDropdownSearch = true;
      this.dropDownSearchInput.focus();
    }
  }

  onDropdownSearch() {
    if (this.dropDownSearchInput.value === '') {
      this.dropDownSearchInput.focus();
      return;
    }

    const { searchUrl } = this.dropdownSearchFormDesktop.dataset;
    const searchQuery = encodeURIComponent(this.dropDownSearchInput.value).replace(/%20/g, '+');

    window.location.href = `${searchUrl}?search=${searchQuery}`;
  }

  // Closes desktop search if the user clicks outside the search field.
  checkClickInSearch(e) {
    if (!(e.target.closest('.dropdown-search-form-desktop')) && !(e.target.closest('.search-form-desktop'))) {
      if (this.showDropdownSearch) {
        this.dropdownSearchFormDesktop.classList.remove('-show-dropdown');
        this.showDropdownSearch = false;
      }
    }
  }
}

// Register class
// if (window.brix && window.brix.registerBlock) {
//   window.brix.registerBlock('brix-multi-menu', Menu.init);
// }

domReady(() => {
  Menu.init();
});
